var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: { title: _vm.title },
        on: { close: _vm.handleCancel },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "bg-red" },
                    [
                      _c("FormTextarea", {
                        attrs: { placeholder: "Add notes here", rows: 10 },
                        model: {
                          value: _vm.contractorNote,
                          callback: function ($$v) {
                            _vm.contractorNote = $$v
                          },
                          expression: "contractorNote",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex pt-3" },
                    [
                      _vm._t("actions", function () {
                        return [
                          _c("UIButton", {
                            attrs: {
                              buttonText: "Add Note",
                              processing: _vm.processing,
                              id: "addNote",
                            },
                            on: { click: _vm.onAdd },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }